import React, { useState ,useEffect} from 'react';
import CustomDrawer from '../../controls/CustomDrawer';
import Button from '../../controls/Button';
import Input from '../../controls/Input';
import Select from '../../controls/Select';
import ImageUpload from '../../controls/ImageUpload';
import { uploadImagesToServer } from '../../../../uploadImageToServer';
import { fetchCategory } from '../../../api/CategoryApi';
import Autocompletesearch from '../../controls/Autocompletesearch';

const BlockDrawer = ({
  setDrawer,
  title,
  initialValues,
  onSave
}) => {
  const [blockType, setBlockType] = useState(initialValues?.BlockType || "image");
  const [loading, setLoading] = useState(false);
  const [values, setValues] = useState({
    BlockText: initialValues?.BlockText || "",
    BlockTextFontSize: initialValues?.BlockTextFontSize || "",
    BlockTextAlignment: initialValues?.BlockTextAlignment || "left",
    BlockVideoURL: initialValues?.BlockVideoURL || "",
    BlockImage: initialValues?.BlockImage || null,
    BlockImageText: initialValues?.BlockImageText || "",
    BlockLinkType: initialValues?.BlockLinkType || "",
    BlockCategoryID: initialValues?.BlockCategoryID || "",
  });

  const [categoryData,setCategoryData] = useState([]);
  const [categoryName, setCategoryName] = useState("");

  const handleChange = (field, value) => {
    setValues(prev => ({
      ...prev,
      [field]: value
    }));
  };

  const handleImageUpload = async (file) => {
    if (!file) {
      handleChange("BlockImage", null);
      return;
    }

    setLoading(true);
    try {
      const uploadurl = await uploadImagesToServer(file);
      if (uploadurl) {
        const imageInfo = {
          Name: file.name,
          Preview: uploadurl,
          Size: file.size
        };
        handleChange("BlockImage", imageInfo);
      }
    } catch (error) {
      console.error("Upload failed:", error);
      toast.error("Image upload failed");
    } finally {
      setLoading(false);
    }
  };

  const handleSave = () => {
    const payload = {
      BlockType: blockType,
      ...values,
      // Ensure all required fields are included
      BlockOmniTag: initialValues?.BlockOmniTag || "",
      BlockSubCategoryID: initialValues?.BlockSubCategoryID || "",
      BlockProductGroupID: initialValues?.BlockProductGroupID || "",
      BlockPageID: initialValues?.BlockPageID || "",
      Class: initialValues?.Class || ""
    };
    console.log("Payload to save:", payload);
    onSave(payload);
  };

    const fetchCategoriesData = async () => {
      try {
        const response = await fetchCategory();
        const filterData = response.productCategories.filter(
          (category) => category.IsDeleted === false && category.ParentID === ""
        );
        setCategoryData(filterData);
        
        if (initialValues?.BlockCategoryID) {
          const category = filterData.find(cat => cat.key === initialValues?.BlockCategoryID);
          if (category) {
            setCategoryName(category.Name);
          }
        }
      } catch (err) {
        console.error("Error fetching categories:", err);
      }
    };
      useEffect(() => {
        fetchCategoriesData();
      }, []);

  const handleClose = () => {
    setDrawer(false);
  };

  return (
    <CustomDrawer
      setDrawer={setDrawer}
      title={title}
      drawerType='small'
      buttons={[
        { Label: "Cancel", Type: "secondary", Icon: "roundedRemove", disabled: loading },
        { Label: "Save", Type: "primary", Icon: "save", disabled: loading },
      ]}
      onButtonClick={(label) => {
        if (label === "Save") {
          handleSave();
        } else if (label === "Cancel") {
          handleClose();
        }
      }}
    >
      <div className='flex flex-col gap-4'>
        <Select
          label="Block Type"
          placeholder="Please Select"
          options={[
            { label: "Image", value: "image" }, 
            { label: "Video", value: "video" }, 
            { label: "Text Content", value: "text" }
          ]}
          value={blockType}
          onChange={(e) => setBlockType(e.target.value)}
          
        />

        {blockType === "image" && 
          <>
            <ImageUpload
              label="Upload Image"
              onImageChange={handleImageUpload}
              onFileInfoChange={(fileInfo) => {}} // Not needed since we're using onImageChange
              imageData={values.BlockImage?.Preview}
              title="Block Image"
            />

            <Input
              label="Image Text"
              type="text"
              value={values.BlockImageText}
              onChange={(e) => handleChange("BlockImageText", e.target.value)}
              placeholder="Enter text to display with image"
            />
          </>
        }

        {blockType === "video" &&
          <>
            <Input
              label="Video URL"
              type="text"
              value={values.BlockVideoURL}
              onChange={(e) => handleChange("BlockVideoURL", e.target.value)}
              placeholder="Enter video URL"
            />
          </>
        }

        {blockType === "text" &&
          <>
            <Input
              label="Text Content"
              type="text"
              value={values.BlockText}
              onChange={(e) => handleChange("BlockText", e.target.value)}
              placeholder="Enter text content"
            />
            
            <Input
              label="Font Size (px)"
              type="number"
              value={values.BlockTextFontSize}
              onChange={(e) => handleChange("BlockTextFontSize", e.target.value)}
              placeholder="Enter font size in pixels"
            />

            <Select
              label="Text Alignment"
              placeholder="Please Select"
              options={[
                { label: "Left", value: "left" }, 
                { label: "Center", value: "center" }, 
                { label: "Right", value: "right" }
              ]}
              value={values.BlockTextAlignment}
              onChange={(e) => handleChange("BlockTextAlignment", e.target.value)}
              
            />
          </>
        }

        <Select
          label="Link Type"
          placeholder="Please Select"
          options={[
            { label: "None", value: "" },
            { label: "Category", value: "category" },
            { label: "Product", value: "product" },
            { label: "URL", value: "url" }
          ]}
          value={values.BlockLinkType}
          onChange={(e) => handleChange("BlockLinkType", e.target.value)}
          
        />

        {values.BlockLinkType === "category" && (
              <Autocompletesearch
              value={categoryName}
              label="Category"
              data={categoryData}
              filterKey={["Name"]}
              defaultDataCount={10}
              onChange={(value) => {
                setCategoryName("");
                handleChange("BlockCategoryID", "");
              }}
              onSelect={(item) => {
                setCategoryName(item.Name);
                handleChange("BlockCategoryID", item.key)
              }}
              placeholder="Search Category"
              renderSuggestion={(item) => (
                <div>
                  <p className="">{item.Name}</p>
                </div>
              )}
            />
        
          
        )}
      </div>
    </CustomDrawer>
  );
};

export default BlockDrawer;